import React, {Fragment, memo, useRef} from 'react'
import {Transformer} from 'react-konva'
import {Shape} from '../../../shapes/Shape'

export const ShapeLayer = memo((props) => {
    const trRef = useRef(null)
    const {shapeProps} = props || {}
    return (
        <Fragment>
            <Shape {...shapeProps} />
            <Transformer ref={trRef} />
        </Fragment>
    )
})

export default ShapeLayer

